<template>
  <div v-if="show" id="cookie-notice">
    <div class="row py-2 px-4">
      <div class="cookie-notice-text col-12 mb-2 text-center col-md-9 mb-md-0 text-md-left">
        <strong>This site uses cookies.</strong> By continuing to use this site you are agreeing to use cookies.
        <a
          href="https://www.carrier.com/carrier/en/worldwide/legal/cookie-policy/"
          target="_blank"
        >Find out more.</a>
      </div>
      <div class="cookie-notice-button col-12 text-center col-md-3 text-md-right">
        <a class="btn" href="#" @click.prevent="submit">Accept</a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      show: true
    };
  },
  methods: {
    submit() {
      this.axios.get(this.route("cookies.accept")).then(response => {
        this.show = false;
      });
    }
  }
};
</script>
